import RequestAuthDataTable_vue_vue_type_script_setup_true_lang_default from "./RequestAuthDataTable.vue_vue_type_script_setup_true_lang.js";
//#region src/v2/blocks/scalar-auth-selector-block/components/RequestAuthDataTable.vue
var RequestAuthDataTable_default = RequestAuthDataTable_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { RequestAuthDataTable_default as default };

//# sourceMappingURL=RequestAuthDataTable.vue.js.map